import { render, staticRenderFns } from "./PrintPackagesDatatable.vue?vue&type=template&id=e0402a94"
import script from "./PrintPackagesDatatable.vue?vue&type=script&lang=js"
export * from "./PrintPackagesDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports